<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">通知信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <div style="width:500px">
          <el-form-item label="通知标题" prop="noticeName">
            <el-input v-model="form.noticeName" placeholder="请输入通知标题" style="width:100%" />
          </el-form-item>
          <el-form-item label="通知内容" prop="noticeContext">
            <el-input v-model="form.noticeContext" type="textarea" :rows="4" placeholder="请输入通知内容" style="width:100%" />
          </el-form-item>
          <el-form-item label="发送时间" prop="sendTime">
            <el-date-picker v-model="form.sendTime" type="datetime" style="width:100%" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" />
          </el-form-item>
          <el-form-item label="发送方式" prop="sendMode">
            <el-checkbox-group v-model="form.sendMode" style="width:100%">
              <el-checkbox :label="0">APP推送</el-checkbox>
              <el-checkbox :label="1">短信推送</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="发送对象" prop="noticeObject">
            <el-radio-group v-model="form.noticeObject" style="width:100%" @change="selectObject">
              <el-radio :label="0">全平台用户</el-radio>
              <el-radio :label="1">按归属企业选择用户</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="isStation" label="" prop="noticeUser">
               <el-input
      placeholder="输入关键字进行过滤"
      v-model="tempText"
    />
          <!-- <STree v-model="firstForm.limiteSite" :data="stationTree" style="width:400px;"></STree> -->
          <GoodStree @check="checkFn"  :tempText="tempText"  :data="datatree" style="width:400px;" />
            <!-- <StreeNew v-model="form.noticeUser" checked-type="user" :data="datatree" style="width:100%;" /> -->
            <!-- <el-input v-model="filterText" placeholder="输入关键字进行过滤" />
            <el-tree
              ref="tree"
              :data="datatree"
              show-checkbox
              node-key="id"
              :filter-node-method="filterNode"
              highlight-current
              :props="defaultProps"
              @check-change="handleCheckChange"
            /> 
            -->
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Xinzengxiaoxi',
  components: {},
  data() {
    return {
      checkArr:[],
      tempText:"",
      filterText: '', // 筛选树的关键字
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      form: {
        noticeUser: [],
        sendMode: []
      },
      rules: {
        noticeName: [{
          required: true,
          message: '请输入通知标题',
          trigger: 'blur'
        }],
        noticeContext: [{
          required: true,
          message: '请输入通知内容',
          trigger: 'blur'
        }],
        sendTime: [{
          required: true,
          message: '请选择发送时间',
          trigger: 'blur'
        }],
        sendMode: [{
          required: true,
          message: '请选择发送方式',
          trigger: 'blur'
        }],
        noticeObject: [{
          required: true,
          message: '请选择发送对象',
          trigger: 'blur'
        }]
      },
      datatree: [],
      isStation: false
    }
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },
  mounted() {
    this.getTree()
  },
  methods: {
    checkFn(e){
      // console.log(e)
      this.checkArr=e
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    handleCheckChange(data, checked, indeterminate) {
      this.form.noticeUser = this.$refs.tree.getCheckedKeys()
    },
    selectObject(val) {
      if (val === 0) {
        this.isStation = false
      } else if (val === 1) {
        this.isStation = true
      }
    },

    cancel() {
      this.$router.go(-1)
    },
    async save() {
      try {
        // 必填校验
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }
      let send = 0
      if (this.form.sendMode.length === 1 && this.form.sendMode[0] === 0) {
        send = 0
      } else if (this.form.sendMode.length === 1 && this.form.sendMode[0] === 1) {
        send = 1
      } else if (this.form.sendMode.length === 2) {
        send = 2
      }

      // const user = this.form.noticeUser.join(',')
      const user = this.checkArr.join(',')

      const data = {
        noticeName: this.form.noticeName,
        noticeContext: this.form.noticeContext,
        sendTime: this.form.sendTime,
        sendMode: send,
        noticeUser: user,
        noticeObject: this.form.noticeObject
      }
      this.$store.dispatch('form/handle', {
        url: '/business/notify/put',
        data: data,
        method: 'put',
        callback: resp => {
          this.$router.go(-1)
        }
      })
    },

    getTree() {
      this.$store.dispatch('form/handle', {
        url: '/business/notify/getOrgAndUser',
        method: 'get',
        callback: resp => {
          this.datatree = resp
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/informManagement/addInformManagement.vue